import Repository from './Repository.js';

class partnerActivitiesRepository extends Repository {
    async getActivities(query) {
        return await this.get('partnerActivities', query);
    }
}

export default new partnerActivitiesRepository();
